<style lang="scss">
.component__marketing-keyword-manager {
  padding: 5px;
}
</style>
<template>
  <div class="component__marketing-keyword-manager">
    <el-row>
      <el-col :sm="12" :xs="12">
        {{ $t('keyword.file_list') }}
        <span v-if="keyword_file.loading">
                    <span class="el-icon-loading"></span>
                    {{ $t('base.loading_data') }}
                </span>
        <template v-else>
          <a href="javascript:;" class="a-link" @click="m__get_keyword_file">{{ $t('base.update') }}</a>
        </template>
      </el-col>
      <el-col :sm="12" :xs="12" class="text-right">
        <el-input size="mini" prefix-icon="el-icon-search" :placeholder="$t('input.placeholder')"
                  v-model="keyword_file.keyword" style="max-width:200px;"></el-input>
      </el-col>
    </el-row>
    <div class="table-responsive" style="margin-top:5px;">
      <table class="table table-hover">
        <thead>
        <tr>
          <th>#</th>
          <th>{{ $t('base.filename') }}</th>
          <th class="text-right">{{ $t('keyword.keyword_number') }}</th>
          <th>{{ $t('base.created_by') }}</th>
          <th>{{ $t('base.created_at') }}</th>
          <th>{{ $t('base.action') }}</th>
        </tr>
        </thead>
        <tbody>
        <template v-if="c__keyword_file__filtered.length===0">
          <tr>
            <td colspan="6" class="text-center">
              {{ $t('keyword.not_files') }} ...
            </td>
          </tr>
        </template>
        <template v-for="(item,index) in c__keyword_file__filtered">
          <tr>
            <td>{{ index + 1 }}</td>
            <td>{{ item.filename }}</td>
            <td class="text-right">{{ item.keyword_count | currency }}</td>
            <td>
              <component__av-char size="24px"
                                  :full_name="item.created_by.display_name"></component__av-char>
              <span style="color:gray;">{{ item.created_by.username }}</span>
              <span style="color:black;">{{ item.created_by.display_name }}</span>
            </td>
            <td>
              {{ item.created_time | timeFormat }}
            </td>
            <td style="width:270px;" v-if="!pick_mode">
              <el-button size="mini" @click="m__export_file_excel(item)">{{ $t('base.download_excel') }}</el-button>
              <el-button size="mini" @click="m__initial_view_keyword_file_detail(item)">
                {{ $t('base.see_detail') }}
              </el-button>
              <el-button type="danger" size="mini" @click="m__try_delete_keyword_file(item)">{{
                  $t('base.delete')
                }}
              </el-button>
            </td>
          </tr>
        </template>
        </tbody>
      </table>
    </div>
    <el-dialog :visible.sync="keyword_file_detail.show" :close-on-click-modal="false" custom-class="no-body"
               width="900px">
      <div slot="title" style="padding:10px">
        <p class="text-title">{{ $t('keyword.file') }}</p>
        <el-input size="mini" v-model="keyword_file_detail.info.filename"></el-input>
        <template v-if="typeof keyword_file_detail.info.created_by!=='undefined'">
          <div style="padding-top:15px;">
            {{ $t('base.created_by') }}
            <component__av-char size="24px"
                                :full_name="keyword_file_detail.info.created_by.display_name"></component__av-char>
            <span style="color:gray;">{{ keyword_file_detail.info.created_by.username }}</span>
            <span style="color:black;">{{ keyword_file_detail.info.created_by.display_name }}</span>
            , {{ $t('base.at') }} {{ keyword_file_detail.info.created_time | timeFormat }}
          </div>
        </template>
        <p class="text-title">{{ $t('keyword.list') }}</p>
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
            <tr>
              <th>#</th>
              <th>{{ $t('base.keyword') }}</th>
              <th>{{ $t('keyword.volume_at_saving') }}</th>
              <th>{{ $t('keyword.bid_price_at_saving') }}</th>
              <th>{{ $t('keyword.current_volume') }}</th>
              <th>{{ $t('keyword.current_bid_price') }}</th>
              <th>{{ $t('keyword.your_bid_price') }}</th>
              <th>{{ $t('base.delete') }}</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(item,index) in keyword_file_detail.info.keyword_json">
              <tr>
                <td>{{ index + 1 }}</td>
                <td>{{ item.keyword }}</td>
                <td>{{ item.sp_volume | currency }}</td>
                <td>{{ item.sp_price | currency }}</td>
                <td>{{ item.now_volume | currency }}</td>
                <td>{{ item.now_price | currency }}</td>
                <td>
                  <el-input-number :min="0" :max="10000" v-model="item.price"
                                   controls-position="right" size="mini"></el-input-number>
                </td>
                <td>
                  <el-button size="mini" @click="m__remove_saved_keyword(index)">{{ $t('base.delete') }}</el-button>
                </td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
        <div style="margin-top:10px; background-color:whitesmoke; color:black; padding:8px;"
             class="text-center">
          {{ $t('keyword.update_note') }}
        </div>
        <div style="padding-top:20px;">
          <el-row>
            <el-col :sm="12" :xs="12">
              <el-button size="mini" type="success" icon="ti-link" @click="m__add_to_recent_keyword">&nbsp;
                {{ $t('keyword.add_to_current_keyword') }}
              </el-button>
            </el-col>
            <el-col :sm="12" :xs="12" class="text-right">
              <el-button size="mini" icon="el-icon-close" @click="keyword_file_detail.show=false">
                {{ $t('base.close') }}
              </el-button>
              <el-button size="mini" icon="ti-save" :loading="keyword_file_detail.loading" type="primary"
                         @click="m__try_update_keyword_file">&nbsp;{{ $t('base.update') }}
              </el-button>
            </el-col>
          </el-row>

        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Component__avChar from '../../components/av_character'
import {SPUserV4} from '../../addon/SPUserV4'
import {fix_ads_mixins} from "../../mixins/fix_ads";

export default {
  name: 'component__keyword_file_manager',

  mixins: [fix_ads_mixins],

  components: {Component__avChar},

  props: {
    user: {
      type: SPUserV4
    },
    product_id: {
      type: Number,
      default: 0
    },
    shop: null
  },

  data() {
    return {
      keyword_file: {
        loading: false,
        list: [],
        keyword: ''
      },
      pick_mode: false,
      keyword_file_detail: {
        show: false,
        loading: false,
        info: {
          _id: '',
          filename: '',
          keyword_json: []
        }
      }
    }
  },

  computed: {
    c__keyword_file__filtered() {
      let keyword = this.remove_unicode(this.keyword_file.keyword)
      return this.keyword_file.list.filter(e => this.remove_unicode(JSON.stringify(e)).includes(keyword))
    }
  },

  beforeMount() {
    this.m__get_keyword_file()
  },

  methods: {
    m__remove_saved_keyword(index) {
      this.keyword_file_detail.info.keyword_json.splice(index, 1)
    },

    m__add_to_recent_keyword() {
      this.keyword_file_detail.show = false
      this.$emit('add_to_recent', this.keyword_file_detail.info)
    },

    m__try_update_keyword_file() {
      this.confirm(this.$t('keyword.update_file_confirm'), () => {
        this.keyword_file_detail.loading = true
        this.$http.put(this.API.marketing.keyword_file.update.replace('_id', this.keyword_file_detail.info._id), {
          ...this.keyword_file_detail.info
        }, this.cf())
          .then(resp => {
            this.keyword_file_detail.loading = false
            this.keyword_file_detail.show = false
            this.ntf_s(resp)
            this.m__get_keyword_file()
          })
          .catch(error => {
            this.keyword_file_detail.loading = false
            this.ntf_w(error)
          })
      })
    },
    async m__get_keyword_sp_info(keyword) {
      if (!this.user) {
        return
      }

      try {
        let info = await this.user.marketing_get_keyword_volume(keyword.keyword, this.product_id)
        keyword.now_volume = info.search_volume
        keyword.now_price = this.m__calculate(info.recommend_price)
      } catch (error) {
        console.log(error)
      }
    },

    async m__export_file_excel(keyword_file) {
      const resp = await this.$http.get(this.API.marketing.keyword_file.detail.replace('_id', keyword_file._id), this.cf())
      if (!resp.body.data.keyword_json || !resp.body.data.keyword_json.length) {
        return
      }

      const save_and_result_resp = await this.$http.post(this.API.URL_API_SRV_2 + '/keyword/save_and_result', {
        mipeeUserId: this.$store.state.userInfo.username,
        keyword: resp.body.data.keyword_json[0].keyword,
        data: resp.body.data.keyword_json.map(i => i.keyword)
      }, this.cf())
      const save_and_result_list = save_and_result_resp.body

      for (const item of resp.body.data.keyword_json) {
        if (!item.sp_volume) {
          const found = save_and_result_list.find(i => i.keyword === item.keyword)
          if (found) {
            item.sp_volume = found.volume
            item.sp_price = this.m__calculate(found.recommendPrice)
          }
        }
      }

      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/excel-fff', {
        data: resp.body.data.keyword_json.map(i => {
          return {
            keyword: i.keyword,
            results: i.results,
            minCPC: i.minCPC,
            maxCPC: i.maxCPC,
            sp_volume: i.sp_volume,
            sp_price: i.sp_price
          }
        })
      }, {
        ...this.cf(),
        responseType: 'blob'
      })

      const url = window.URL.createObjectURL(new Blob([response.body]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `keywords-${Date.now()}.xlsx`)
      document.body.appendChild(link)
      link.click()
    },

    m__initial_view_keyword_file_detail(keyword_file) {
      this.$http.get(this.API.marketing.keyword_file.detail.replace('_id', keyword_file._id), this.cf())
        .then(resp => {
          this.keyword_file_detail.info = resp.body.data
          this.keyword_file_detail.info.keyword_json = resp.body.data.keyword_json.map(e => {
            return {
              ...e,
              now_price: 0,
              now_volume: 0
            }
          })
          if (this.product_id !== 0) {
            this.keyword_file_detail.info.keyword_json.forEach(e => {
              this.m__get_keyword_sp_info(e)
            })
          }
          this.keyword_file_detail.show = true
        })
        .catch(error => {
          this.ntf_w(error)
        })
    },
    m__try_delete_keyword_file(keyword_file) {
      this.confirm(this.$t('base.delete_file_confirm'), () => {
        this.$http.delete(this.API.marketing.keyword_file.delete.replace('_id', keyword_file._id), this.cf())
          .then(resp => {
            this.ntf_s(resp)
            this.m__get_keyword_file()
          })
          .catch(error => {
            this.ntf_w(error)
          })
      })
    },
    m__get_keyword_file() {
      this.keyword_file.loading = true
      this.$http.get(this.API.marketing.keyword_file.list, this.cf())
        .then(resp => {
          this.keyword_file.loading = false
          this.keyword_file.list = resp.body.data
        })
        .catch(error => {
          this.keyword_file.loading = false
          this.ntf_w(error)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/keyword/component__keyword_file_manager.vue